import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Wed Jul 18 2018
 * @author BPo
 * @author LZe
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { RoundingRuleConverter } from '@logio/common-be-fe';
import { Inject } from '@logio/typescript-ioc';
import { CONSTANTS } from '../../../constants';
import logger from '../../../shared/logger';
import api from '../../api';
import { CRUTransportLayer } from '../CRUTransportLayer';
export var RoundingRuleLayer =
/*#__PURE__*/
function (_CRUTransportLayer) {
  _inherits(RoundingRuleLayer, _CRUTransportLayer);

  function RoundingRuleLayer() {
    _classCallCheck(this, RoundingRuleLayer);

    return _possibleConstructorReturn(this, _getPrototypeOf(RoundingRuleLayer).call(this, CONSTANTS.API.ENDPOINTS.ROUNDING_RULE));
  }

  _createClass(RoundingRuleLayer, [{
    key: "getConverter",
    value: function getConverter() {
      return this.converter;
    }
    /**
     * Test rounding rules, returns rounded price
     */

  }, {
    key: "round",
    value: function round(price, weighted) {
      var roundPromise = api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.ROUNDING_RULE).concat(CONSTANTS.API.ENDPOINTS.ROUNDING_RULE_ROUND)).post({
        price: price,
        weighted: weighted
      }, {
        responseType: 'json'
      }).then(function (result) {
        return Promise.resolve(result.data);
      }).catch(function (error) {
        // logger.error(error);
        return Promise.reject(error);
      });
      return roundPromise;
    }
  }, {
    key: "delete",
    value: function _delete(id) {
      var updatePromise = api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.ROUNDING_RULE, "/").concat(id)).delete().then(function (response) {
        return Promise.resolve();
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
      return updatePromise;
    }
  }]);

  return RoundingRuleLayer;
}(CRUTransportLayer);

__decorate([Inject, __metadata("design:type", RoundingRuleConverter)], RoundingRuleLayer.prototype, "converter", void 0);